import { render } from "./FormFeedback.vue?vue&type=template&id=0cd389d7"
import script from "./FormFeedback.vue?vue&type=script&lang=js"
export * from "./FormFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__